/* Galnuv metals bar: gold and silver spot per troy ounce in CAD.
   Each source is fetched on its own, so one failing API never blanks the bar.
   The last good values are remembered for 12 h so the bar fills instantly on the next page. */
(function () {
  var KEY = 'gnv_metals_v2', MAX_AGE = 12 * 3600 * 1000;
  var prev = { g: null, s: null };
  function fmt(n) { return n.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function el(id) { return document.getElementById(id); }
  function getJSON(url) {
    var ctl = window.AbortController ? new AbortController() : null;
    var t = ctl ? setTimeout(function () { ctl.abort(); }, 8000) : null;
    return fetch(url, ctl ? { signal: ctl.signal } : {}).then(function (r) {
      if (t) clearTimeout(t);
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }
  function firstOk(fns) {
    return fns.reduce(function (p, fn) { return p.catch(fn); }, Promise.reject());
  }
  function cadRate() {
    return firstOk([
      function () { return getJSON('https://api.frankfurter.dev/v1/latest?base=USD&symbols=CAD').then(function (j) { if (!(j.rates && j.rates.CAD)) throw 0; return j.rates.CAD; }); },
      function () { return getJSON('https://open.er-api.com/v6/latest/USD').then(function (j) { if (!(j.rates && j.rates.CAD)) throw 0; return j.rates.CAD; }); }
    ]);
  }
  function spot(sym) {
    return getJSON('https://api.gold-api.com/price/' + sym).then(function (j) { if (!(j.price > 0)) throw 0; return j.price; });
  }
  function show(id, val, chId, before) {
    var e = el(id); if (!e || !(val > 0)) return;
    e.textContent = fmt(val);
    var c = el(chId);
    if (c && before > 0 && Math.abs(val - before) >= 0.01) {
      var d = val - before;
      c.textContent = (d > 0 ? '▲ ' : '▼ ') + Math.abs(d).toFixed(2);
      c.style.color = d > 0 ? '#22c55e' : '#ef4444';
    }
  }
  function save(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  function load() {
    try { var o = JSON.parse(localStorage.getItem(KEY) || 'null'); if (o && Date.now() - o.t < MAX_AGE) return o; } catch (e) {}
    return null;
  }
  function settle(p) { return p.then(function (v) { return v; }, function () { return null; }); }

  function update() {
    var cached = load();
    Promise.all([settle(spot('XAU')), settle(spot('XAG')), settle(cadRate())]).then(function (r) {
      var rate = r[2] || (cached && cached.rate) || null;
      var g = r[0] && rate ? r[0] * rate : null;
      var s = r[1] && rate ? r[1] * rate : null;
      if (g) { show('gnv-gold', g, 'gnv-gold-ch', prev.g); prev.g = g; }
      if (s) { show('gnv-silver', s, 'gnv-silver-ch', prev.s); prev.s = s; }
      if (g || s) save({ t: Date.now(), g: g || (cached && cached.g), s: s || (cached && cached.s), rate: rate });
      ready();
    });
  }
  // Prices stay hidden (CSS) until a real number is in place; no "..." placeholders.
  function ready() {
    var bar = el('gnv-ticker'); if (!bar) return;
    var has = el('gnv-gold') && /\d/.test(el('gnv-gold').textContent);
    bar.classList.toggle('gnv-ready', !!has);
  }
  function init() {
    var c = load();
    if (c) { show('gnv-gold', c.g, null, null); show('gnv-silver', c.s, null, null); prev.g = c.g; prev.s = c.s; }
    ready();
    update();
    setInterval(update, 60000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
